export const environment = {
  production: true,
  websiteName: "IROC Kontaktlinsen",
  cookie: "",
  widgetUid: "96af445d-a4b0-434a-a604-37e338cf5200",
  color2: "#746660",
  color2_80: "#008FBA80",
  color4: "#004e85",
  color7: "#004e85",
  email: "info@iroc-kontaktlinsen.ch",
  telephone: "+41 43 488 38 00",
  translationsPath: "widget",
  shouldShowResources: false,
  font: {
    name: "Dax",
    url: "assets/fonts/dax/dax-regular.woff2",
    format: "woff2",
  },
  apiPath: "https://stage.realm.doc-booker.com/ab-new-mt",
};



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/environments/environment.ts